import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Chip,
  Grid,
  Typography,
} from "@mui/material";

import { MONO, tokens } from "./../theme";
import { Eyebrow } from "./ui";

const STATUS_COLOR = { running: "info", pending: "default", error: "error", canceled: "default", done: "success" };

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

function fmtDuration(a, b) {
  if (!a || !b) return "—";
  const s = (new Date(b) - new Date(a)) / 1000;
  if (s < 0) return "—";
  if (s < 60) return `${s.toFixed(1)}s`;
  return `${Math.floor(s / 60)}m ${Math.round(s % 60)}s`;
}

function Field({ label, value }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Eyebrow sx={{ mb: 0.25 }}>{label}</Eyebrow>
      <Typography sx={{ fontFamily: MONO, fontSize: ".82rem", overflowWrap: "anywhere" }}>{value ?? "—"}</Typography>
    </Box>
  );
}

export default function JobDetailModal({ job, onClose }) {
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <span>
          Run · <span style={{ fontFamily: MONO }}>{job.generator}</span>
        </span>
        <Chip label={job.status} size="small" color={STATUS_COLOR[job.status] || "default"} sx={{ ml: "auto" }} />
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mb: job.error ? 2.25 : 0 }}>
          <Grid item xs={6} sm={3}>
            <Field label="GPU" value={job.gpu_index != null ? `GPU ${job.gpu_index}` : "—"} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <Field label="VRAM" value={job.vram_mb ? `${Math.round(job.vram_mb).toLocaleString()} MB` : "—"} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <Field label="Type" value={job.media_type} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <Field label="Duration" value={fmtDuration(job.started_at, job.finished_at)} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Field label="Created" value={fmtTime(job.created_at)} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Field label="Started" value={fmtTime(job.started_at)} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Field label="Finished" value={fmtTime(job.finished_at)} />
          </Grid>
          <Grid item xs={12}>
            <Field label="Job ID" value={job.id} />
          </Grid>
        </Grid>

        {job.error && (
          <Box>
            <Eyebrow sx={{ mb: 0.75, color: tokens.crit }}>Error</Eyebrow>
            <Box
              component="pre"
              sx={{
                m: 0,
                p: 2,
                maxHeight: 340,
                overflow: "auto",
                fontFamily: MONO,
                fontSize: ".76rem",
                lineHeight: 1.55,
                bgcolor: "#0e1b2e",
                color: "#e6b4b4",
                borderRadius: 2,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                userSelect: "text",
              }}
            >
              {job.error}
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
